import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';

ClassNameGenerator.configure(
  (componentName) => `megatron-${componentName.replace('Mui', 'megatron')}`
);

// ClassNameGenerator.configure(
//   (componentName) => `megatron-${componentName}`
// );

// ClassNameGenerator.configure(
//   // Do something with the componentName
//   (componentName) => componentName,
// );